import React, { useRef } from "react";
import { Box, Chip, Stack, TextField, Typography } from "@mui/material";
import { InputCustom, InputTextarea } from "../ui-elements/input-ui";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { PetitionProps, PetitionPropsTwo } from "../../interface/posts";
import { tip_data, tip_data_two } from "./data";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const PetitionTwo = ({
  next,
  prev,
  petition_data,
  setPetition_data,
}: PetitionPropsTwo) => {
  const quillRef = useRef<ReactQuill>(null);
  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          height: "4px",
          background: "url(/assets/icons/posts/line-02.png)",
        }}
      />
      <Stack sx={{ mt: 3, px: 2 }}>
        <Typography
          color="black"
          variant="body2"
          sx={{
            fontSize: 15,

            fontWeight: 500,
          }}
        >
          Tell your story
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#7991A4",
          }}
        >
          Clearly explain the issue. Check our tips below for guide.
        </Typography>
      </Stack>
      <Stack sx={{ my: 2, px: 2 }}>
        <Typography
          variant="caption"
          sx={{
            color: "#7991A4",
          }}
        >
          Petition description
        </Typography>
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={petition_data?.context}
          onChange={(value) =>
            setPetition_data((prev) => ({ ...prev, context: value }))
          }
        />
      </Stack>
      <Stack sx={{ px: 2 }} direction={"row"} justifyContent={"flex-end"}>
        <Chip
          label="Back"
          onClick={() => prev()}
          sx={{
            backgroundColor: "#92A5B5",
            color: "#fafafa",
            mx: 1,
          }}
        />
        <Chip
          label="Continue"
          onClick={() => next()}
          color="primary"
          sx={{
            color: "#fafafa",
            px: 1,
          }}
        />
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <FiberManualRecordIcon sx={{ color: "#459173", fontSize: 10 }} />
        <FiberManualRecordIcon sx={{ color: "#459173", fontSize: 10 }} />
        <FiberManualRecordIcon sx={{ color: "#C2CDD6", fontSize: 10 }} />
      </Box>
      <Box
        sx={{
          backgroundColor: "#FAFbFc",
          py: 3,
          px: 2,
          borderRadius: 8,
        }}
      >
        <Typography variant="caption" color="black">
          Tips
        </Typography>
        {tip_data_two?.map((val, id) => (
          <Box
            key={id}
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: 3,
            }}
          >
            <FiberManualRecordIcon
              sx={{ color: "#000", fontSize: 8, mt: "4px" }}
            />
            <Box style={{ marginBottom: 8, width: "98%" }}>
              <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                {val.main}
              </Typography>
              <Typography sx={{ fontSize: "13px" }}>{val.content}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PetitionTwo;
